import { useSelector } from "react-redux";
import OverdueInvoices from "./OverdueInvoices/OverdueInvoices";
import SchoolsInRedStatus from "./SchoolsInRedStatus/SchoolsInRedStatus";
import UpcomingInvoices from "./UpcomingInvoices/UpcomingInvoices";
import UpcomingPayments from "./UpcomingPayments/UpcomingPayments";
import CollectionsSummary from "./CollectionsSummary/CollectionsSummary";
import LabStatusTracker from "./LabStatusTracker/LabStatusTracker";
import LabTaskStatus from "./LabTaskStatus/LabTaskStatus";
import { RootState } from "@/redux/store";

const Dashboard = () => {
  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  const roles = loggedInUserData?.role || [];

  // Helper to check if user has a given role
  const hasRole = (role: string) =>
    Array.isArray(roles) && roles.includes(role);

  return (
    <div className="p-7">
      <div className=" bg-white text-600 text-[16px] font-bold p-4 rounded-lg">
        Hello, {loggedInUserData?.name}
      </div>

      {/* Collections Summary - Full Width */}
     <div className="mt-6">
  {hasRole("LABS_TEAM_HEAD") || hasRole("LABS_TEAM") ? (
    <>
      
      <LabStatusTracker />
      <div className="mt-6">
      <LabTaskStatus />
      </div>
    </>
  ) : (
    <CollectionsSummary />
  )}
</div>


    {!(hasRole("LABS_TEAM_HEAD") || hasRole("LABS_TEAM")) && (
  <>
    {/* Other Components */}
    <div className="grid grid-cols-1 gap-6 mt-6">
      {/* SUPER_ADMIN: UpcomingInvoices & UpcomingPayments in one grid */}
      {hasRole("SUPER_ADMIN") && (
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <UpcomingInvoices />
          <UpcomingPayments />
        </div>
      )}

      {/* UpcomingInvoices (hidden for CRM_HEAD, REGION_HEAD, RELATIONSHIP_MANAGER) */}
      {!hasRole("SUPER_ADMIN") &&
        !(hasRole("CRM_HEAD") || hasRole("REGION_HEAD") || hasRole("RELATIONSHIP_MANAGER")) && (
          <UpcomingInvoices />
        )}

      {/* UpcomingPayments */}
      {!hasRole("SUPER_ADMIN") && !hasRole("FINANCE_TEAM") && (
        <div className="grid grid-cols-1 lg:grid-cols-1">
          <UpcomingPayments />
        </div>
      )}

      {/* SchoolsInRedStatus & OverdueInvoices */}
      {!hasRole("FINANCE_TEAM") && (
        <div
          className={`grid grid-cols-1 gap-6 ${
            hasRole("SUPER_ADMIN") ||
            hasRole("CRM_HEAD") ||
            hasRole("REGION_HEAD") ||
            hasRole("RELATIONSHIP_MANAGER")
              ? "lg:grid-cols-2"
              : ""
          }`}
        >
          <SchoolsInRedStatus />
          <OverdueInvoices />
        </div>
      )}
    </div>
  </>
)}


    </div>
  );
};

export default Dashboard;
